import { Typography } from '@design-system/components/typography/typography';
import * as styles from './OnboardingCard.css';

type OnboardingCardType = {
  title: string;
  description: string;
  image: string;
  link: string;
  onClick?: () => void;
};

export const OnboardingCard = ({
  title,
  description,
  image,
  link,
  onClick,
}: OnboardingCardType) => {
  return (
    <a
      href={link}
      className={styles.card}
      target="_blank"
      rel="noreferrer noopener"
      onClick={() => {
        onClick && onClick();
      }}
    >
      <Typography variant="title" size="large">
        {title}
      </Typography>
      <Typography variant="body" fontWeight="medium">
        {description}
      </Typography>
      <div className={styles.imageWrapper}>
        <img
          src={image}
          className={styles.image}
          alt="Creator community collage"
        />
      </div>
    </a>
  );
};
